// https://system-ui.com/theme/
// https://tailwindcss.com/docs/customizing-colors#default-color-palette
// https://chakra-ui.com/theme#colors

// @TODO: Separar en variables

const theme = {
  colors: {
    black: '#000000',
    white: '#ffffff',
    gray: '#f5f5f5',
    darkGray: '#757575',
    mediumGray: '#b5b5b5',
    lavender: '#E4E8F5',
    lavenderSoft: '#f8faff',
    cadetBlue: '#ACB1C1',
    trout: '#52555F',
    emerald: '#1be86d',
    primary: '#3e72df',
    primarySoft: '#edf2fc',
    secondary: '#ff9726',
    success: '#1ef59f',
    warning: '#ffc24d',
    error: '#f44336',
    info: '#00b0ff',
    leaves: '#9026f9',
    overtimes: '#00b0ff',
    debtTimes: '#f44034',
    vacations: '#f9ae55',
    swaps: '#1ef59f',
    vacationSwaps: '#ff6838',
    // gray: {
    //   #f9f9f9 Fondo productos equipamiento
    //   #f0f0f0 Bordes
    //   #a4a4a4 Atrubutos equipamiento
    //   #808080 Hora de fichaje
    //   #757575 Cómputo positivo/negativo, Horas a pagar, Tiempos debidos, Calendario (fines de semana)
    //   #616161 Textos, Estado pendiente
    // },
    red: {
      // #ffcbcb Fichaje fin gradiente (#ffcbcb, #ffaaaa)
      // #ffaaaa Fichaje fin gradiente (#ffcbcb, #ffaaaa)
      // #ff4d14 Vacaciones por disfrutar
      // #f44336 Incidencias
      // #ff2838 Vacaciones sin asignar
    },
    orange: {
      // #ffc24d Timeview gradiente (#ff6b00, #ffc24d)
      // #f9ae55 Vacaciones
      // #ffa538 Jornadas excedidas, Tipos de fichajes
      // #ff6b00 Timeview gradiente (#ff6b00, #ffc24d)
      // #ff6838 Permutas de vacaciones
    },
    yellow: {
      // #f5e01e Estado en espera
    },
    green: {
      // #cbffd4 Fichaje inicio gradiente (#cbffd4, #7effbb)
      // #7effbb Fichaje inicio gradiente (#cbffd4, #7effbb)
      // #1ef59f Permutas
      // #1fd989 Permutas (ilustraciones solo?)
    },
    teal: {},
    blue: {
      // #00b0ff Tiempos excedidos, botones equipamiento
      // #0493fa Tiempos excedidos (ilustraciones solo?)
      // #4d71f0 Botón gradiente (#4d71f0, #4dd3f0)
      // #3366ff Método de fichaje
    },
    cyan: {
      // #4dd3f0 Botón gradiente (#4d71f0, #4dd3f0)
    },
    purple: {
      // #9026f9 Ausencias
      // #7e3de7 Ausencias (ilustraciones solo?)
    },
    pink: {},
    brown: {
      // #795548 Permuta deshecha
    },
    admin: {
      50: '#efe8ff',
      100: '#cbbcf9',
      200: '#a991ef',
      300: '#8765e7',
      400: '#6439df',
      500: '#4b20c6',
      600: '#3a199b',
      700: '#291170',
      800: '#180a45',
      900: '#09021d',
    },
    config: {
      50: '#fceff2',
      100: '#ddd7d9',
      200: '#c1bfbf',
      300: '#a6a6a6',
      400: '#8c8c8c',
      500: '#737373',
      600: '#595959',
      700: '#413f40',
      800: '#292526',
      900: '#16090d',
    },
  },

  gradients: {
    yellow: { from: '#FFEA7D', to: '#FFCF97' },
    orange: { from: '#FFA664', to: '#FFD28F' },
    secondary: { from: '#ff6b00', to: '#ffc24d' },
    red: { from: '#ff7d9c', to: '#f8763e' },
    blood: { from: '#ff4444', to: '#ff9497' },
    sakura: { from: '#ed728b', to: '#a15b88' },
    pink: { from: '#FC8ADC', to: '#FFB7B7' },
    mauve: { from: '#c0b9db', to: '#e3b6d2' },
    purple: { from: '#B67DFF', to: '#EF8FFF' },
    indigo: { from: '#7643ed', to: '#9d80e7' },
    space: { from: '#130c6f', to: '#B67DFF' },
    blue: { from: '#7643ed', to: '#a9eeff' },
    sky: { from: '#a9eeff', to: '#00b2ff' },
    lapislazuli: { from: '#34b4e5', to: '#3ed3b4' },
    mint: { from: '#3ed3b4', to: '#a7ff7d' },
    green: { from: '#a7ff7d', to: '#8fffe4' },
    lime: { from: '#75D384', to: '#DFF87B' },
    jade: { from: '#7cbba8', to: '#b8d8c0' },
    wood: { from: '#98be93', to: '#7c956f' },
    bronze: { from: '#bea193', to: '#ffe6cb' },
    gray: { from: '#EBEBEB', to: '#CFCED9' },
    black: { from: '#A1A1A1', to: '#606060' },
    white: { from: '#ECE9E6', to: '#fefefe' },
  },

  randomColors: [
    '#2dcd85',
    '#B67DFF',
    '#f8763e',
    '#00b0ff',
    '#ffc24d',
    '#d23719',
    '#1121ab',
    '#e90f66',
    '#8bcbb5',
    '#f74845',
    '#cf826b',
    '#c6ec2f',
    '#16514d',
  ],

  fonts: {
    heading: 'Roboto, sans-serif',
    body: 'Roboto, sans-serif',
    mono: 'Roboto Mono, monospace',
  },

  fontSizes: {
    '2xs': '0.625rem',
    xs: '0.75rem',
    sm: '0.875rem',
    base: '1rem',
    lg: '1.125rem',
    xl: '1.25rem',
    '2xl': '1.5rem',
    '3xl': '1.875rem',
    '4xl': '2.25rem',
    '5xl': '3rem',
    '6xl': '4rem',
  },

  fontWeights: {
    light: 300,
    normal: 400,
    medium: 500,
    bold: 700,
  },

  lineHeights: {},

  space: {},

  sizes: {},

  shadows: {},

  zIndices: {},
};

export default theme;
